// extracted by mini-css-extract-plugin
export default {"container":"ExpenseList_container__Zae6N","addItemMessage":"ExpenseList_addItemMessage__xwyCP"};